function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PaginationVue from '@/components/PaginationVue';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import tasks from '@/js/tasks';
import { envConfig } from '@/js/constants';
var IBK_ATTRIBUTE_ABREV = 'ibk';
var IBK_GCP_ATTRIBUTE_PROJECT = process.env.VUE_APP_ENV === 'prod' ? 'intercorp-data-storage-pv' : 'dev-intercorp-data-storage';
var IBK_GCP_ATTRIBUTE_DATASET = 'bi_ibk_attribute_party';
var BQ_MODEL_PROJECT = process.env.VUE_APP_ENV === 'prod' ? 'stalwart-motif-270218' : 'dev-intercorp-data-operation';
var BQ_MODEL_DATASET = 'inca_attribute_automation_us';
var IBK_AWS_OUTPUT_SCHEMA = process.env.VUE_APP_ENV === 'prod' ? 'sand_ibk_itcm_base' : 'dev_sand_ibk_itcm_base_rlink';
export default {
  name: 'CreateAttributeDetail',
  components: {
    PaginationVue: PaginationVue
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tab: null,
      loading: false,
      loadingPeriods: false,
      downloadingScript: false,
      info: {},
      logItems: [],
      executionItems: [],
      periodItems: [],
      logHeaders: [{
        text: 'Descripción',
        value: 'description'
      }, {
        text: 'Tipo de evento',
        value: 'event_type'
      }, {
        text: 'Usuario',
        value: 'user'
      }, {
        text: 'Respuesta',
        value: 'response'
      }, {
        text: 'Creación',
        value: 'creation_date'
      }],
      executionHeaders: [{
        text: 'Fecha inicio',
        value: 'start_date'
      }, {
        text: 'Fecha fin',
        value: 'end_date'
      }, {
        text: 'Usuario',
        value: 'creation_user'
      }, {
        text: 'Estado',
        value: 'status'
      }],
      periodHeaders: [{
        text: 'Período',
        value: 'process_date'
      }, {
        text: 'Origen',
        value: 'source'
      }, {
        text: 'Fecha Creación',
        value: 'creation_date'
      }, {
        text: 'Usuario',
        value: 'creation_user'
      }, {
        text: 'Filas Leídas',
        value: 'filas_leidas',
        sortable: false
      }, {
        text: 'Filas Cargadas',
        value: 'filas_cargadas',
        sortable: false
      }, {
        text: 'Última fecha carga',
        value: 'ultima_fecha_carga',
        sortable: false
      }],
      pagination: {
        logs: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        },
        executions: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        },
        periods: {
          current: 1,
          limit: envConfig.pagintaionSize,
          total: 0
        }
      }
    };
  },
  created: function created() {
    this.fetchDetail();
    this.fetchExecutions();
  },
  computed: {
    gcpTableName: function gcpTableName() {
      var nombre = this.item.nombre_tabla || '';
      if (!nombre) return '-';
      if (nombre.startsWith('sand_ibk_attr_')) {
        return "".concat(IBK_GCP_ATTRIBUTE_PROJECT, ".").concat(IBK_GCP_ATTRIBUTE_DATASET, ".ba_").concat(IBK_ATTRIBUTE_ABREV, "_attr_").concat(nombre.substring('sand_ibk_attr_'.length));
      }
      return "".concat(IBK_GCP_ATTRIBUTE_PROJECT, ".").concat(IBK_GCP_ATTRIBUTE_DATASET, ".ba_").concat(IBK_ATTRIBUTE_ABREV, "_attr_").concat(nombre);
    },
    modelTableName: function modelTableName() {
      var nombre = this.item.nombre_tabla || '';
      if (!nombre) return '';
      return "".concat(BQ_MODEL_PROJECT, ".").concat(BQ_MODEL_DATASET, ".modelo_").concat(nombre);
    },
    awsOutputTable: function awsOutputTable() {
      var nombre = this.item.nombre_tabla || '';
      if (!nombre) return '';
      return "".concat(IBK_AWS_OUTPUT_SCHEMA, ".").concat(nombre);
    }
  },
  methods: {
    fetchDetail: function fetchDetail() {
      var _this = this;
      if (!this.item.automate_id) return;
      this.loading = true;
      UseCasesService.getLogStatus(this.item.automate_id).then(function (response) {
        var records = response.data && response.data.records || {};
        _this.info = records;
        _this.logItems = records.logs || [];
        _this.pagination.logs.total = _this.logItems.length;
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this.translate('error_messages.error_general'));
      }).finally(function () {
        _this.loading = false;
      });
    },
    fetchExecutions: function fetchExecutions() {
      var _this2 = this;
      if (!this.item.automate_id) return;
      this.loadingPeriods = true;
      UseCasesService.getAutomationExecutions(this.item.automate_id).then(function (response) {
        var data = response.data || {};
        _this2.executionItems = data.executions || data.records || [];
        _this2.periodItems = data.periods || [];
        _this2.pagination.executions.total = _this2.executionItems.length;
        _this2.pagination.periods.total = _this2.periodItems.length;
      }).catch(function () {
        _this2.executionItems = [];
        _this2.periodItems = [];
      }).finally(function () {
        _this2.loadingPeriods = false;
      });
    },
    downloadOriginalScript: function () {
      var _downloadOriginalScript = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.item.automate_id) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.downloadingScript = true;
              _context.p = 2;
              _context.n = 3;
              return UseCasesService.downloadAutomationScript(this.item.automate_id);
            case 3:
              response = _context.v;
              _context.n = 4;
              return this.handleScriptDownloadResponse(response);
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              tasks.toast.error(this.$t('create_attribute.detail.download_script_error'));
            case 6:
              _context.p = 6;
              this.downloadingScript = false;
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 5, 6, 7]]);
      }));
      function downloadOriginalScript() {
        return _downloadOriginalScript.apply(this, arguments);
      }
      return downloadOriginalScript;
    }(),
    handleScriptDownloadResponse: function () {
      var _handleScriptDownloadResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(response) {
        var headers, blob, contentType, payload, data, downloadUrl, sqlContent, base64Content, filename, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              headers = response && response.headers || {};
              blob = response && response.data;
              if (blob) {
                _context2.n = 1;
                break;
              }
              throw new Error('Empty download response');
            case 1:
              contentType = String(headers['content-type'] || blob.type || '').toLowerCase();
              if (!contentType.includes('application/json')) {
                _context2.n = 6;
                break;
              }
              _t2 = JSON;
              _context2.n = 2;
              return blob.text();
            case 2:
              payload = _t2.parse.call(_t2, _context2.v);
              data = payload.data || payload;
              downloadUrl = data.download_url || data.url || data.signed_url || data.presigned_url;
              if (!downloadUrl) {
                _context2.n = 3;
                break;
              }
              window.open(downloadUrl, '_blank');
              return _context2.a(2);
            case 3:
              sqlContent = data.content || data.script || data.sql || data.original_script || data.script_sql;
              base64Content = data.base64 || data.script_file || data.script_base64;
              filename = data.filename || data.file_name || this.originalScriptFileName();
              if (!sqlContent) {
                _context2.n = 4;
                break;
              }
              this.downloadBlob(new Blob([sqlContent], {
                type: 'text/plain;charset=utf-8'
              }), filename);
              return _context2.a(2);
            case 4:
              if (!base64Content) {
                _context2.n = 5;
                break;
              }
              this.downloadBlob(this.base64ToBlob(base64Content), filename);
              return _context2.a(2);
            case 5:
              throw new Error('Unsupported script payload');
            case 6:
              this.downloadBlob(blob, this.fileNameFromHeaders(headers) || this.originalScriptFileName());
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleScriptDownloadResponse(_x) {
        return _handleScriptDownloadResponse.apply(this, arguments);
      }
      return handleScriptDownloadResponse;
    }(),
    downloadBlob: function downloadBlob(blob, filename) {
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = this.safeFileName(filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    base64ToBlob: function base64ToBlob(base64Content) {
      var cleanBase64 = String(base64Content).split(',').pop();
      var decoded = atob(cleanBase64);
      var bytes = new Uint8Array(decoded.length);
      for (var i = 0; i < decoded.length; i++) {
        bytes[i] = decoded.charCodeAt(i);
      }
      return new Blob([bytes], {
        type: 'text/plain;charset=utf-8'
      });
    },
    fileNameFromHeaders: function fileNameFromHeaders(headers) {
      var disposition = headers['content-disposition'] || headers['Content-Disposition'] || '';
      var utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
      if (utfMatch) return decodeURIComponent(utfMatch[1]);
      var asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
      return asciiMatch ? asciiMatch[1] : '';
    },
    originalScriptFileName: function originalScriptFileName() {
      var filename = this.info.script_filename || this.info.script_name || this.item.procedure_name;
      if (filename) return filename;
      var tableName = this.item.nombre_tabla || 'automatizacion';
      return "".concat(tableName, "_original.sql");
    },
    safeFileName: function safeFileName(filename) {
      var clean = String(filename || 'script.sql').replace(/[\\/:*?"<>|]+/g, '_').trim();
      return /\.sql$/i.test(clean) ? clean : "".concat(clean, ".sql");
    },
    formatDate: function formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('es-PE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    formatDateTime: function formatDateTime(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('es-PE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getDateAndHours: function getDateAndHours(created) {
      if (!created) {
        return {
          date: '-',
          hour: '-'
        };
      }
      var value = String(created);
      var localMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?)?$/);
      if (localMatch) {
        var _localMatch = _slicedToArray(localMatch, 7),
          year = _localMatch[1],
          month = _localMatch[2],
          day = _localMatch[3],
          _localMatch$ = _localMatch[4],
          hour = _localMatch$ === void 0 ? '00' : _localMatch$,
          _localMatch$2 = _localMatch[5],
          minute = _localMatch$2 === void 0 ? '00' : _localMatch$2,
          _localMatch$3 = _localMatch[6],
          second = _localMatch$3 === void 0 ? '00' : _localMatch$3;
        return {
          date: "".concat(day, "-").concat(month, "-").concat(year),
          hour: "".concat(hour, ":").concat(minute, ":").concat(second)
        };
      }
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return {
          date: value,
          hour: ''
        };
      }
      var parts = new Intl.DateTimeFormat('es-PE', {
        timeZone: 'America/Lima',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).formatToParts(date);
      var part = function part(type) {
        var match = parts.find(function (p) {
          return p.type === type;
        });
        return match ? match.value : '';
      };
      return {
        date: "".concat(part('day'), "-").concat(part('month'), "-").concat(part('year')),
        hour: "".concat(part('hour'), ":").concat(part('minute'), ":").concat(part('second'))
      };
    },
    copyText: function copyText(text) {
      if (!text) return;
      var onSuccess = function onSuccess() {
        return tasks.toast.success('Copiado');
      };
      var onError = function onError() {
        return tasks.toast.error('No se pudo copiar');
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onSuccess).catch(onError);
        return;
      }
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        var copied = document.execCommand('copy');
        copied ? onSuccess() : onError();
      } catch (e) {
        onError();
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }
};